import * as React from "react";

import styled from "../../theme/styled";
import { ColumnWidthWrapper } from "../confines-wrappers";
import DynamicVideo from "../dynamic-video";
import {
  IFieldTechnicalArticle,
  IFieldTechnicalArticleColumnType
} from "./field-technical-article";

interface IProps {
  type: IFieldTechnicalArticleColumnType;
  content: IFieldTechnicalArticle;
}

interface IParagraphVideoColumnWidthWrapper {
  className: string;
  type: IFieldTechnicalArticleColumnType;
}

const ParagraphVideoColumnWidthWrapper = styled<
  IParagraphVideoColumnWidthWrapper,
  "div"
>("div")`
  .content-container {
    .content-wrapper {
      .image {
        padding-top: 8%;
        width: 100%;

        &:first-child {
          padding-top: 0;
        }
      }
    }
  }
`;

const ParagraphVideoColumnWidth = ({ type, content }: IProps) => {
  const videoUrl = content.field_video_url;
  const autoplay = content.field_video_autoplay;
  const videoCaption = content.field_video_caption;

  if (!videoUrl) {
    return null;
  }

  return (
    <ParagraphVideoColumnWidthWrapper
      className="paragraph-video-column-width"
      type={type}
    >
      <ColumnWidthWrapper>
        <DynamicVideo
          videoUrl={videoUrl}
          autoplay={autoplay}
          videoCaption={videoCaption}
        />
      </ColumnWidthWrapper>
    </ParagraphVideoColumnWidthWrapper>
  );
};

export default ParagraphVideoColumnWidth;
